import { FunctionComponent } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { imageResizer } from 'utils/image';
import { replaceSpecialChars, shorten, withVariables } from 'utils/string';

import Tooltip from 'components/layout/Tooltip';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsSmallJobBox: FunctionComponent<Props> = ({ job, iconsAlts }) => {
    const router = useRouter();

    return (
        <StyledComponent className="public-layout-jobs-small-job-box">
            <a
                className='offer-link'
                    href={ job?.cbopUrl? job.cbopUrl : withVariables(Routes?.PublicJob, { slug: job?.slug }, { jobCitySlug: job?.primaryCity?.id })} 
                    target={job?.cbopUrl ? "_blank" : undefined}
            >
                <div className="offer-header">
                    <Tooltip
                        name={job?.name}
                        text={(
                            <div className="tooltip-name">
                                {job?.name}
                            </div>
                        )}
                        reactTooltipProps={{
                            disable: Boolean(job?.name.length < 30),
                            type: 'dark',
                            effect: 'solid',
                            place: 'bottom',
                            delayShow: 200,
                            multiline: true,
                        }}
                    >

                        <a
                            className="offer-link"
                            href={ job?.cbopUrl? job.cbopUrl : withVariables(Routes?.PublicJob, { slug: job?.slug }, { jobCitySlug: job?.primaryCity?.id })} 
                            target={job?.cbopUrl ? "_blank" : undefined}
                        >
                            <div
                                className="offer-name"
                                dangerouslySetInnerHTML={{ __html:  shorten(replaceSpecialChars(job?.name), 30, true) }}
                            />
                        </a>

                    </Tooltip>
                    <div className="image-container">
                        <div
                            className="offer-image"
                            style={{
                                backgroundImage: `url(${job.createSource === 'cbop' ? '/images/jobs/e-praca-logo.svg' : imageResizer(job.companyLogo?.imageUrl, { width: 200 }) || '/images/jobs/image-placeholder.svg'})`,

                            }}
                        />
                    </div>
                </div>
                <div className="offer-content">
                    <div
                        className="company-name"
                        dangerouslySetInnerHTML={{ __html: shorten(job?.companyName, 25, true) }}
                    />
                    <div className="content-description">
                        {Array.isArray(job?.jobAgreements) && job?.jobAgreements?.length > 0 && (
                            <div className="description">
                                <img
                                    className="icon"
                                    src="/images/icons/bullet.svg"
                                    loading="lazy"
                                    width="20"
                                    height="auto"
                                    alt={iconsAlts?.agreement}

                                />
                                <div
                                    className="title"
                                    dangerouslySetInnerHTML={{ __html: shorten(job?.jobAgreements[0]?.name, 15, true) }}
                                />
                            </div>
                        )}
                        {job?.jobTime && (
                            <div className="description">
                                <img
                                    className="icon"
                                    src="/images/icons/bullet2.svg"
                                    loading="lazy"
                                    width="20"
                                    height="auto"
                                    alt={iconsAlts?.time}
                                />
                                <div
                                    className="title"
                                    dangerouslySetInnerHTML={{ __html: job?.jobTime?.name }}
                                />
                            </div>
                        )}
                        <div className="description">
                            <img
                                className="icon"
                                src="/images/icons/bullet3.svg"
                                loading="lazy"
                                width="20"
                                height="auto"
                                alt={iconsAlts?.location}
                            />
                            <div
                                className="title highlighted"
                                dangerouslySetInnerHTML={{ __html: shorten(job?.primaryCity?.companyFullAddress, 15, true) || 'Brak lokalizacji' }}
                            />
                        </div>
                    </div>
                </div>
            </a>

        </StyledComponent>
    );
};

export default PublicLayoutJobsSmallJobBox;